import React from "react";
import classnames from "classnames";
import {
  formatUnitAmount,
  getPriceMinUnitAmount
} from "components/FormerEditor/common/currency";
import Pill from "components/Pill";
import { PILL_THEME } from "components/Pill";
import { priceIntervalCountLabel } from "utils/price";
import { getPriceTaxBehaviorLabel } from "utils/taxRate";
import { BILLING_SCHEME } from "utils/constants/payment";
import { PRICE_VARIES_LABEL } from "components/FormerEditor/common/preview";

const PriceInfo = ({ price, model, autoTaxes = false }) => {
  const taxBehavior = getPriceTaxBehaviorLabel(price);
  const hasFooter = price.nickname || taxBehavior;

  const priceLabel =
    price.billing_scheme === BILLING_SCHEME.PER_UNIT
      ? `${formatUnitAmount({
          amount: getPriceMinUnitAmount(price),
          currency: price.currency
        })} x ${model.quantity}`
      : PRICE_VARIES_LABEL;

  return (
    <div className="flex flex-column flex-row-ns w-100 items-center-ns pt2">
      <div className="flex flex-row items-center">
        <div className="fw5 f6 pr2 hairline-1">{priceLabel}</div>
        <div
          className={classnames("fw5 f6 pl2 bl hairline-1", {
            pr2: price.nickname
          })}
        >
          <Pill theme={PILL_THEME.SLIM} copy={priceIntervalCountLabel(price)} />
        </div>
      </div>
      {hasFooter && (
        <div className="flex flex-row items-center pt2 pt0-ns bn pl2-ns ml2-ns bl-ns hairline-1">
          {taxBehavior && (
            <div
              className={classnames("f7 pr1", {
                "pr2 mr2 hairline-1 br-ns": price.nickname
              })}
            >
              {taxBehavior}
            </div>
          )}
          {price.nickname && <div className="fw5 f7">{price.nickname}</div>}
        </div>
      )}
    </div>
  );
};

export default PriceInfo;
